/**
 * Simple event bus: features subscribe to slideChanged / userChanged.
 * Orchestrator (or adapter) emits; no central dispatcher calling every feature.
 * @see docs/architecture/GREENFIELD-LECTURA-ARCHITECTURE.md
 */

const listeners = new Map<string, Set<(...args: unknown[]) => void>>();

export function on(event: string, cb: (...args: unknown[]) => void): () => void {
  if (!listeners.has(event)) listeners.set(event, new Set());
  listeners.get(event)!.add(cb);
  return () => listeners.get(event)?.delete(cb);
}

export function emit(event: string, ...args: unknown[]): void {
  listeners.get(event)?.forEach((cb) => {
    try {
      cb(...args);
    } catch (e) {
      console.error('[LecturaNext]', e);
    }
  });
}

export const EVENTS = Object.freeze({
  SLIDE_CHANGED: 'slideChanged',
  USER_CHANGED: 'userChanged',
  DRAWER_OPEN: 'drawerOpen',
  /** Prefill chat composer after drawer is open (handled in chat.ts). */
  OPEN_CHAT_COMPOSER: 'openChatComposer'
} as const);
